/** @jsxImportSource @emotion/react */
import cx from 'classnames';
import { type JSX } from 'react';

import { PUBLIC_URL } from 'utils/consts';
import { useStyles } from 'utils/useStyles';

import { customSignupStyles } from './CustomSignup.styles';

export const BulletRenderer = ({
  listItems,
  isNumber = false,
}: {
  listItems: Array<string | JSX.Element>;
  isNumber?: boolean;
}) => {
  const styles = useStyles(customSignupStyles);

  return (
    <ul data-testid={'bullet-renderer-list'} css={styles.ulStyle}>
      {listItems.map((item, index) => (
        <li key={typeof item === 'string' ? item : index} className={cx('list-item')} css={styles.liStyle}>
          <span>
            {!isNumber ? (
              <img
                data-testid={'bullet-checkbox'}
                src={`${PUBLIC_URL}/img/icons/checkbox.svg`}
                alt={'checkbox.svg'}
                css={styles.checkbox}
              />
            ) : (
              index + 1
            )}
          </span>
          <span css={styles.li}>{item}</span>
        </li>
      ))}
    </ul>
  );
};
